<!-- HTML -->
<template>
  <pl-dialog :title="'Oops!'" :size="'xs'" :disableOutsideClick="true">
    <body class="px-7 pt-7 pb-4 flex-grow overflow-hidden">
      <div v-if="deleteCourse" class="mt-3 justify-center items-center">
        <span class="justify-center">This course was removed by your teacher <br />
          or an administrator at your school.
        </span>
      </div>
      <div v-else class="mt-3">
        <div class="text-center mb-3">
          <i class="fa-regular fa-face-frown text-4xl text-primary"></i>
        </div>
        <div class="text-center text-gray-800 px-10">
          Your <span class="font-semibold">access to this course</span> has been removed by a <span class="font-semibold">teacher</span>
          or an <span class="font-semibold">administrator </span>at your school. You must <span class="font-semibold">contact them</span> to 
          be added back before your can join the Roundtable.
        </div>
      </div>
    </body>
    <footer class="flex my-8 center items-center">
      <button @click="backToDashboard" class="px-5 py-2 bg-primary rounded cursor-pointer text-white font-semibold">
        Go to Dashboard
      </button>
    </footer>
  </pl-dialog>
</template>

<!-- JS -->
<script>
  import { mapGetters } from 'vuex';

  export default {
    props: {
      deleteCourse: {
        type: Boolean,
        default() {
          return false;
        },
      },
    },
    computed: {
      ...mapGetters([]),
    },
    methods: {
      backToDashboard() {
        this.$emit('closeModal');
        if (this.$route.name === 'dashboard')  {
          window.location.reload();
        }
        this.$router.push({ name: 'dashboard' });
      },
    },
  };
</script>

<!-- CSS -->
<style scoped lang="stylus">
  @import '~app/global-stylus.styl'
</style>



// WEBPACK FOOTER //
// removedStudentFromSchoolModal.vue?4ce3a795